import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
@observer
class ArtistSearchBar extends React.Component {
	render () {
		return (
			<div className="grid-x margin-0">
                <input type="text" placeholder="Search" data-ta="ArtistSearchBar" className="margin-bottom-0" _id="ArtistSearchBar" onChange={ this.props.searchChange } value={ this.props.searchTerm } style={{borderRadius: '1vw'}} />
			</div>
		);
    }
}

export default ArtistSearchBar;
